import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { selectorDataMathMatch } from "../../../../redux/selector";
import { TYPE_GET_DATE } from "../../../../helper/const";
import {
  formatDataMytelMagicDetail,
  getDateChangeTime,
} from "../../../../helper/helper";
import FilterTimeDate from "../../components/FilterTimeDate";
import Tables from "../../../components/Tables";
import styled from "styled-components";
import _ from "lodash";

export default function Detail({ handleGetData, tabActive }) {
  const { result = {} } = useSelector(selectorDataMathMatch)?.revenue;
  const [date, setDate] = useState(getDateChangeTime(TYPE_GET_DATE.now));
  const { dataHourMap = [] } = result;
  console.log(result);

  useEffect(() => {
    if (tabActive !== "2") return;
    handleGetData(date, date);
  }, [date, tabActive]);

  const columns = useMemo(() => {
    if (_.isEmpty(dataHourMap[date])) {
      return [];
    }

    return formatDataMytelMagicDetail(dataHourMap[date]);
  }, [date, dataHourMap]);

  return (
    <Container>
      <div
        className="position-relative d-flex justify-right mb-2"
        style={{ justifyContent: "right" }}
      >
        <FilterTimeDate date={date} setDate={setDate} />
      </div>
      <Tables
        columns={columns}
        title="Overview statistic table"
        isHiddenPagination={false}
      />
    </Container>
  );
}

const Container = styled.div`
  .panel-sortable {
    tr:last-child {
      td {
        font-weight: 600;
      }
    }
  }
`;
